/* tslint:disable */
/* eslint-disable */
export enum InterestType {
  Simple = 'SIMPLE',
  Compound = 'COMPOUND'
}
